// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ball-loader {
  width: 250px;
  height: 83.3333333333px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
}

.ball-loader-ball {
  will-change: transform;
  height: 62.5px;
  width: 62.5px;
  border-radius: 50%;
  background-color: var(--loader-balls);
  display: inline-block;
  animation: grow 1s ease-in-out infinite alternate;
  transform-origin: 50% 50%;
}
.ball-loader-ball.ball1 {
  margin-right: 22.7272727273px;
}
.ball-loader-ball.ball2 {
  margin-right: 22.7272727273px;
  animation-delay: -0.33s;
}
.ball-loader-ball.ball3 {
  animation-delay: -0.66s;
}

@keyframes grow {
  0% {
    transform: scale(1);
    background-color: var(--loader-balls);
  }
  50% {
    background-color: var(--loader-balls);
  }
  100% {
    transform: scale(0.2);
    background-color: var(--loader-balls);
  }
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/styles/loader.scss"],"names":[],"mappings":"AAGA;EACE,YAJM;EAKN,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,aAAA;AAFF;;AAKA;EACE,sBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,qCAAA;EACA,qBAAA;EACA,iDAAA;EACA,yBAAA;AAFF;AAIE;EACE,6BAAA;AAFJ;AAKE;EACE,6BAAA;EACA,uBAAA;AAHJ;AAME;EACE,uBAAA;AAJJ;;AAQA;EACE;IACE,mBAAA;IACA,qCAAA;EALF;EAQA;IACE,qCAAA;EANF;EASA;IACE,qBAAA;IACA,qCAAA;EAPF;AACF","sourcesContent":["$width: 250px;\n$animationDuration: 1s;\n\n.ball-loader {\n  width: $width;\n  height: calc($width / 3);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  display: flex;\n}\n\n.ball-loader-ball {\n  will-change: transform;\n  height: calc($width / (1 * 4));\n  width: calc($width / (1 * 4));\n  border-radius: 50%;\n  background-color: var(--loader-balls);\n  display: inline-block;\n  animation: grow $animationDuration ease-in-out infinite alternate;\n  transform-origin: 50% 50%;\n\n  &.ball1 {\n    margin-right: calc($width / 11);\n  }\n\n  &.ball2 {\n    margin-right: calc($width / 11);\n    animation-delay: - $animationDuration * .33;\n  }\n\n  &.ball3 {\n    animation-delay: - $animationDuration * .66;\n  }\n}\n\n@keyframes grow {\n  0% {\n    transform: scale(1);\n    background-color: var(--loader-balls);\n  }\n\n  50% {\n    background-color: var(--loader-balls);\n  }\n\n  100% {\n    transform: scale(.2);\n    background-color: var(--loader-balls);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
